import React from 'react'

function DeckLogEPSCoverBackPage() {
  return (
    <>
      <div className="flex flex-col justify-between py-0 px-2 mb-4 print-page-break-before-page">
        <table className="w-full  border border-gray-800">
          <thead>
            <tr className=''>
              <th colSpan={4} className='py-1 px-2'>WIND</th>
            </tr>
            <tr className='border border-gray-800'>
              <th className='py-1 px-2 border border-gray-800'>
                No.
              </th>
              <th className='py-1 px-2 border border-gray-800'>
                Velocity in Knots
              </th>
              <th className='py-1 px-2 border border-gray-800'>
                Descriptive Terms
              </th>
              <th className='py-1 px-2 border border-gray-800'>
                SEA CRITERION
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">0.</td>
              <td className="py-1 px-2 border border-gray-800">Less than 1</td>
              <td className="py-1 px-2 border text-left border-gray-800">Calm</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Sea like a mirror.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">1.</td>
              <td className="py-1 px-2 border border-gray-800">1 to 3</td>
              <td className="py-1 px-2 border text-left border-gray-800">Light Air</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Ripples with the appearance of scales are formed, but without foam crest.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">2.</td>
              <td className="py-1 px-2 border border-gray-800">4 to 6</td>
              <td className="py-1 px-2 border text-left border-gray-800">Light Breeze</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Small wavelets, still short but more pronounced; crests have a glassy appearance and do not break.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">3.</td>
              <td className="py-1 px-2 border border-gray-800">7 to 10</td>
              <td className="py-1 px-2 border text-left border-gray-800">Gentle Breeze</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Large wavelets. Crests begin to break. Foam of glossy appearance; perhaps scattered white horses.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">4.</td>
              <td className="py-1 px-2 border border-gray-800">11 to 16</td>
              <td className="py-1 px-2 border text-left border-gray-800">Moderate Breeze</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Small waves, becoming longer; fairly frequent white horses.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">5.</td>
              <td className="py-1 px-2 border border-gray-800">17 to 21</td>
              <td className="py-1 px-2 border text-left border-gray-800">Fresh Breeze</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Moderate waves, taking a more pronounced long foam; many white horses are formed.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">6.</td>
              <td className="py-1 px-2 border border-gray-800">22 to 27</td>
              <td className="py-1 px-2 border text-left border-gray-800">Strong Breeze</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Large waves begin to foam; the white foam crests are more extensive everywhere.
                (Probably some spray).
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">7.</td>
              <td className="py-1 px-2 border border-gray-800">28 to 33</td>
              <td className="py-1 px-2 border text-left border-gray-800">Moderate Gale</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Sea heaps up and white foam from breaking waves begins to be blown in streaks along the
                direction of the wind.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">8.</td>
              <td className="py-1 px-2 border border-gray-800">34 to 40</td>
              <td className="py-1 px-2 border text-left border-gray-800">Fresh Gale</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Moderately high waves of greater length; edges of crests break into spindrift.
                The foam is blown in well-marked streaks along the direction of the wind.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">9.</td>
              <td className="py-1 px-2 border border-gray-800">41 to 47</td>
              <td className="py-1 px-2 border text-left border-gray-800">Strong Gale</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                High waves. Dense streaks of foam along the direction of the wind. Sea begins to roll.
                Spray may affect visibility.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">10.</td>
              <td className="py-1 px-2 border border-gray-800">48 to 55</td>
              <td className="py-1 px-2 border text-left border-gray-800">Whole Gale</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Very high waves with long overhanging crests. The resulting foam, in great
                patches, is blown in dense with streaks along the direction of the wind. On
                the whole, the surface of the sea takes a white appearance. The rolling of
                the sea becomes heavy and shocklike. Visibility affected.
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">11.</td>
              <td className="py-1 px-2 border border-gray-800">56 to 63</td>
              <td className="py-1 px-2 border text-left border-gray-800">Storm</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                Exceptionally high waves. (Small and medium-sized ships might be for a
                time lost to view behind the waves.) The sea is completely covered with
                the long white patches of foam lying along the direction of the wind.
                Everywhere the edges of the wave crests are blown into froth. Visibility
                affected
              </td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">12.</td>
              <td className="py-1 px-2 border border-gray-800">64 to 71</td>
              <td className="py-1 px-2 border text-left border-gray-800">Hurricane</td>
              <td className="py-1 px-2 text-left border border-gray-800">
                The air is filled with foam and spray. Sea completely white with driving
                spray, visibility very seriously affected.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex flex-col justify-between py-0 px-2 mb-4">
        <table className="w-full  border border-gray-800">
          <thead>
            <tr className=''>
              <th colSpan={3} className='py-1 px-2'>FOG AND VISIBILITY SCALE</th>
            </tr>
            <tr className='border border-gray-800'>
              <th className='py-1 px-2 border border-gray-800'>
                No.
              </th>
              <th className='py-1 px-2 border border-gray-800'>
                DESCRIPTIVE TERMS
              </th>
              <th className='py-1 px-2 border border-gray-800'>
                LIMITS OF VISIBILITY
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">90.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Very thick fog</td>
              <td className="py-1 px-2 border text-left border-gray-800">Less than 150 feet</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">91.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Thick fog</td>
              <td className="py-1 px-2 border text-left border-gray-800">150 to 600 feet</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">92.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Fog</td>
              <td className="py-1 px-2 border text-left border-gray-800">600 feet to 1/4 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">93.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Moderate fog</td>
              <td className="py-1 px-2 border text-left border-gray-800">1/4 to 1/2 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">94.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Mist of haze or very poor visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">1/2 to 1 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">95.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Poor visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">1 to 2 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">96.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Moderate visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">2 to 5 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">97.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Good visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">5 to 10 mile</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">98.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Very good visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">10 to 25 miles</td>
            </tr>
            <tr className="text-center border border-gray-800">
              <td className="py-1 px-2 border border-gray-800">99.</td>
              <td className="py-1 px-2 border text-left border-gray-800">Excellent visibility</td>
              <td className="py-1 px-2 border text-left border-gray-800">25 miles or over</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='flex gap-4 w-full py-0 px-2 text-sm'>
        <div className="flex flex-col justify-between w-1/2">
          <table className="w-full  border border-gray-800">
            <thead>
              <tr className=''>
                <th colSpan={2} className='py-1 px-2'>STATE OF SEA</th>
              </tr>
              <tr className='border border-gray-800'>
                <th className='py-1 px-2 border border-gray-800'>
                  Descriptive Term
                </th>
                <th className='py-1 px-2 border border-gray-800'>
                  Height of Wave in Feet
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Calm (Glassy)</td>
                <td className="py-1 px-2 border border-gray-800">0</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Ripple</td>
                <td className="py-1 px-2 border border-gray-800">0 - 1</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Smooth (Wavelets)</td>
                <td className="py-1 px-2 border border-gray-800">1 - 2</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Slight</td>
                <td className="py-1 px-2 border border-gray-800">2 - 4</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Moderate</td>
                <td className="py-1 px-2 border border-gray-800">4 - 8</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Rough</td>
                <td className="py-1 px-2 border border-gray-800">8 - 13</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Very rough</td>
                <td className="py-1 px-2 border border-gray-800">13 - 20</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">High</td>
                <td className="py-1 px-2 border border-gray-800">20 - 30</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Very high</td>
                <td className="py-1 px-2 border border-gray-800">30 - 45</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-1 px-2 border border-gray-800">Phenomenal</td>
                <td className="py-1 px-2 border border-gray-800">over 45</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="flex flex-col justify-between w-1/2">
          <table className="w-full  border border-gray-800">
            <thead>
              <tr className=''>
                <th className='border border-gray-800'></th>
                <th colSpan={2} className='py-1 px-2'>CHARACTER OF SWELL</th>
              </tr>
              <tr className='border border-gray-800'>
                <th className='py-1 px-2 border border-gray-800'>
                </th>
                <th className='py-1 px-2 border border-gray-800'>
                  Descriptive Term
                </th>
                <th className='py-1 px-2 border border-gray-800'>
                  Length in Feet
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800"></td>
                <td className="py-2 px-2 border border-gray-800">Short</td>
                <td className="py-2 px-2 border border-gray-800">10 - 300</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800 text-right" rowSpan={2}>A</td>
                <td className="py-2 px-2 border border-gray-800">Average</td>
                <td className="py-2 px-2 border border-gray-800">300 - 600</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800">Long</td>
                <td className="py-2 px-2 border border-gray-800">Over 600</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800 text-right" rowSpan={4}>B</td>
                <th className="py-2 px-2 border border-gray-800"></th>
                <th className="py-2 px-2 border border-gray-800">Height in Feet</th>
              </tr>

              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800">Low</td>
                <td className="py-2 px-2 border border-gray-800">0 to 7</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800">Moderate</td>
                <td className="py-2 px-2 border border-gray-800">7 to 13</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800">Heavy</td>
                <td className="py-2 px-2 border border-gray-800">Over 13</td>
              </tr>
              <tr className="text-center border border-gray-800">
                <td className="py-2 px-2 border border-gray-800 text-right">C</td>
                <td className="py-2 px-2 border border-gray-800">Confused</td>
                <td className="py-2 px-2 border border-gray-800">Non-measurable. Indistinct, Crossing</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default DeckLogEPSCoverBackPage